<template>
  <b-tabs
    content-class="mt-0"
    fill
    justified
    v-model="tabIndex"
    class="support-options-for-start-fundraising"
    nav-class="border-0 text-blue text-base font-weight-bold
                  align-items-stretch justify-content-center flex-wrap mt-3"
    active-nav-item-class="border-top-0 border-left-0 border-right-0
          border-2 border-primary bg-primary text-white"
  >
    <b-tab title-link-class="h-100 d-flex justify-content-center align-items-center">
      <template #title>
        <span v-orphans>{{ $t('form.typeOfSupport.tab.1') }}</span>
      </template>
      <TypeOfSupportBox
        v-if="tabIndex === 0"
        v-model="paymentType"
        :label="$t('form.label.purchase')"
        :description="$t('form.typeOfSupport.description.1')"
        :option="PaymentType.purchase"
        class="border border-2"
      ></TypeOfSupportBox>
      <TypeOfSupportBox
        v-if="tabIndex === 0"
        v-model="paymentType"
        :amount="amount"
        :label="$t('form.label.instalments')"
        :description="$t('form.typeOfSupport.description.2')"
        :option="PaymentType.instalments"
        :options="instalmentsOption"
        equalOptions
        :useOrphansDirective="false"
        @amount="amountEventInstalments"
        class="mt-3 border border-2"
      ></TypeOfSupportBox>
    </b-tab>
    <b-tab title-link-class="h-100 d-flex justify-content-center align-items-center">
      <template #title>
        <span v-orphans>{{ $t('form.typeOfSupport.tab.2') }}</span>
      </template>
      <TypeOfSupportBox
        v-if="tabIndex === 1"
        v-model="paymentType"
        :amount="amount"
        :label="$t('form.label.fundraising')"
        :description="$t('form.typeOfSupport.description.3')"
        :option="PaymentType.fundraising"
        :options="fundraisingOption"
        :showRadioBox="false"
        @amount="amount = $event"
        class="border border-2"
      ></TypeOfSupportBox>
    </b-tab>
  </b-tabs>
</template>

<script setup lang="ts">
import { ref, watch, watchEffect } from 'vue'
// @ts-ignore
import { storeToRefs } from 'pinia'

import TypeOfSupportBox from '@/components/formOfSupport/TypeOfSupportBox.vue'

import { SOFT_PAYMENT_LIMIT, DEFAULT_INSTALMENT_AND_FUNDRAISING_AMOUNT } from '@/constants/payment'
import useTransactionDataStore from '@/stores/transactionData'

import { PaymentMethod, PaymentType } from '@/types'
import { usePaymentOptions } from '@/composables'

type Props = {
  shouldSetDefaults: boolean
}
const props = withDefaults(defineProps<Props>(), {
  shouldSetDefaults: true
})

const transactionDataStore = useTransactionDataStore()
const { amount, paymentType, methodType } = storeToRefs(transactionDataStore)

const setDefaultsForStartFundraising = () => {
  paymentType.value = PaymentType.purchase
  amount.value = SOFT_PAYMENT_LIMIT
  methodType.value = PaymentMethod.online
}
if (props.shouldSetDefaults) setDefaultsForStartFundraising()

const tabIndex = ref<number>(paymentType.value === PaymentType.fundraising ? 1 : 0)

const { instalmentsOption, fundraisingOption } = usePaymentOptions()
function amountEventInstalments(event: number): void {
  amount.value = event
  paymentType.value = PaymentType.instalments
}

watchEffect(() => {
  paymentType.value = tabIndex.value === 0 ? PaymentType.purchase : PaymentType.fundraising
})

watch(paymentType, (newType: number): void => {
  amount.value = null
  if (newType === PaymentType.purchase) {
    amount.value = SOFT_PAYMENT_LIMIT
  }
  if (newType === PaymentType.instalments || newType === PaymentType.fundraising) {
    amount.value = DEFAULT_INSTALMENT_AND_FUNDRAISING_AMOUNT
  }
})
</script>
<style lang="scss">
.support-options-for-start-fundraising {
  .nav-link {
    color: inherit;
  }
}
</style>
